import DPrint from "../common/print/print-4.0.0";
export default {
    bind(el,binding){
        const lodop = new DPrint.WindowLODOP({});
        const frame=document.getElementById(lodop.iframeId);
        frame.setAttribute("style","width:100%;height:100%");
        el.appendChild(frame);
        el.__lodop=lodop;
        new DPrint.Template({templateName:"test",render:binding.value});
        DPrint.on("taskErrorPrint",console.log);
        lodop.onReady();
    },
    update(el,binding){
        if(binding.oldValue!==binding.value){
            const tem = DPrint.Template.getTemplate("test");
            const lodop=el.__lodop;
            tem.render=binding.value.render;
            lodop.onReady().then(()=>{
                lodop.document.body.innerHTML="";
                lodop.NewPage();
                tem.renderTask(new DPrint.Task({data:binding.value.testData}),lodop)
            });
        }
    },
    unbind(el){
        el.__lodop=null;
    }
}
